import Ky from "ky";
import { actions as errorActions } from "../store/modules/error";
const PROTOCOL = process.env.VUE_APP_PROTOCOL ? process.env.VUE_APP_PROTOCOL : "";
const HOST = process.env.VUE_APP_HOST ? process.env.VUE_APP_HOST : "";
const BASE_URL = `${PROTOCOL}://${HOST}`;

// API SETUP
export function getCookie(name) {
    const value = "; " + document.cookie;
    const parts = value.split("; " + name + "=");
    if (parts.length === 2)
        return parts
            .pop()
            .split(";")
            .shift();
}

export const ky = Ky.extend({
    prefixUrl: BASE_URL,
    credentials: "include",
    timeout: false, // in ms, will cancel request, false = off
    retry: {
        limit: 2,
        methods: ["get"]
        // statusCodes: [413]
    },
    hooks: {
        beforeRequest: [
            (request, options) => {
                if (["POST", "PUT", "PATCH", "DELETE"].includes(options.method)) {
                    options.headers.set("X-Xsrftoken", getCookie("_xsrf"));
                }
            }
        ],
        afterResponse: [
            async (_request, _options, response) => {
                if (response.ok === false) {
                    let body;
                    try {
                        body = await response.json();
                    } catch (err) {
                        //pass
                    }
                    const details = { request: _request, options: _options, response: response, data: body };
                    errorActions.handleError(details);
                    throw details;
                }
            }
        ]
    }
});
